// 📁 components/PublicProfile/FriendActions.jsx
// Handles send, cancel, accept, decline, and unfriend buttons.
import React from 'react';

const FriendActions = ({
    isCurrentUser,
    alreadyFriends,
    requestSent,
    incomingRequest,
    isBlocked,
    onSend,
    onCancel,
    onAccept,
    onDecline,
    onModalOpen // This handles accept, decline, and unfriend
}) => {
    // 1. If viewing own profile, hide all actions
    if (isCurrentUser) return null;

    // 2. If the user is blocked, show the message and stop
    if (isBlocked) {
        return (
            <div className="friend-actions">
                <p className="status-message blocked">User is blocked ❌</p>
            </div>
        );
    }

    return (
        <div className="friend-actions">

            {/* 3. Highest Priority: Incoming Request (Accept/Decline) */}
            {incomingRequest ? (
                <>
                    <button className="friend-request-btn" onClick={() => onModalOpen('accept')}>
                        Accept Request ✅
                    </button>
                    <button className="cancel-request-btn" onClick={() => onModalOpen('decline')}>
                        Decline Request ❌
                    </button>
                </>
            ) :

                /* 4. Next Priority: Already Friends (Unfriend) */
                alreadyFriends ? (
                    <>
                        <button
                            className="unfriend-btn" // <-- NEW CLASS
                            onClick={() => onModalOpen('unfriend')}
                        >
                            Unfriend
                        </button>
                        <p className="status-message friends">You’re already friends ✅</p>
                    </>
                ) :

                    /* 5. Next Priority: Request Sent (Cancel) */
                    requestSent ? (
                        <button className="cancel-request-btn" onClick={onCancel}>
                            Cancel Request ❌
                        </button>
                    ) :

                        /* 6. Lowest Priority: Default State (Send Request) */
                        (
                            <button className="friend-request-btn" onClick={onSend}>
                                Send Friend Request
                            </button>
                        )}

        </div>
    );
};

export default FriendActions;